import { AddressDto } from "./../dtos/addressDto";
import { CustomerSearchRequestDto } from "../dtos/customerSearchRequestDto";
import { ErpAddressType } from "@/dtos/erpAddressType";
import { PowderFinish } from "@/dtos/powderFinish";
import { PowderStructure } from "@/dtos/powderStructure";

export default {
	currentCustomerSearchRequest(state: any, getters: any) {
		var request = new CustomerSearchRequestDto();
		request.searchTerm = state.suchbegriff;
		request.countries = state.customerFilterCountries;
		request.isVolltextSearch = state.customerVolltextSuche;
		request.sortingType = state.customerSortingType;
		request.tagIds = state.customerFilterTags.map((c: any) => c.id);
		return request;
	},
	customerPersonalAddress(state: any) {
		let address: AddressDto = {
			id: 99, // Not used
			givenName: "", // Not used od customer anymore
			surname: "", // Not used od customer anymore
			companyName: state.detailCustomerInfo.companyName,
			street: state.detailCustomerInfo.street,
			zip: state.detailCustomerInfo.plz,
			town: state.detailCustomerInfo.town,
			country: state.detailCustomerInfo.country,
			phone: state.detailCustomerInfo.phone, // General phone
			eMail: state.detailCustomerInfo.eMail, // General email
			customerId: parseInt(state.detailCustomerInfo.customerId),
			isDefault: false,
			type: ErpAddressType.Personal,
		};
		return address;
	},
	regionNameFromCountryCode: (state: any) => (countryCode: string) => {
		switch (countryCode) {
			case "CH":
				return "Schweiz/Liechtenstein";
			case "DE":
				return "Deutschland";
			case "AT":
				return "Österreich";
			default:
				return "Unknown";
		}
	},
	getWeldlineString: (state: any) => (weldlines: any) => {
		let text = "";

		if (weldlines.length === 1) {
			text = "1 Schweißnaht";
		} else if (weldlines.length > 1) {
			text = `${weldlines.length} Schweißnähte`;
		}
		const numberOfCorners = weldlines.reduce((a: any, b: any) => {
			return a + b.corners.length;
		}, 0);
		if (numberOfCorners === 1) {
			text += ` | 1 Ecke`;
		} else if (numberOfCorners > 1) {
			text += ` | ${numberOfCorners} Ecken`;
		}
		if (weldlines.some((w: any) => w.clean)) {
			text += ` | verputzt`;
		} else {
			text += ` | unverputzt`;
		}
		return text;
	},
	getPowdercoatingFinishText: (state: any) => (value: number) => {
		switch (value) {
			case PowderFinish.Matt: {
				return "Matt";
			}
			case PowderFinish.Glossy: {
				return "Glanz";
			}
			default: {
				return "Nicht verfügbar";
			}
		}
	},
	getPowdercoatingStructureText: (state: any) => (value: number) => {
		switch (value) {
			case PowderStructure.Smooth: {
				return "Glatt";
			}
			case PowderStructure.Fine: {
				return "Fein";
			}
			case PowderStructure.Rough: {
				return "Grob";
			}
			default: {
				return "Nicht verfügbar";
			}
		}
	},
};
